import axios from "axios";
import { User } from "@/interfaces/user";

export class AuthService {
    public static async getUser(token: string): Promise<User | null> {
        const uri = "/api/signin/user";
        const response = await axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async updateUserlikeChat(
        user: string,
        token: string
    ): Promise<User> {
        const uri = "/api/user/userlikechat";
        const response = await axios.post(
            uri,
            {
                userLikeChatWidgetId: user,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    public static async updateDisplayname(
        displayname: string,
        id: string,
        token: string
    ): Promise<User> {
        const uri = "/api/user/displayname";
        const response = await axios.patch(
            uri,
            {
                id: id,
                displayname: displayname,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    public static async validateUserlikeChatWidgetId(
        id: string
    ): Promise<number> {
        return await axios
            .get(
                `https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/${id}.js`
            )
            .then(response => {
                return response.status;
            })
            .catch(error => {
                return error.status;
            });
    }

    public static async testingUsecase(
        token: string,
        formData: Array<{ title: string; answer: string }>
    ): Promise<{ message: string }> {
        const uri = "/api/user/testingUsecase";
        const response = await axios.post(
            uri,
            { formData },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }
}
